import ContextProvider from 'config/context_provider';
import { QueryStringParser } from 'utils/query_string_parser';

export function buildOptionsUrl(optionsUrl, optionsUrlParams, noContext) {
	if (noContext !== undefined) {
		return !optionsUrl
			? null
			: `${optionsUrl}?${QueryStringParser.parseFromObjectsArray(optionsUrlParams)}`;
	}

	return !optionsUrl
		? null
		: `${ContextProvider.getContext()}${optionsUrl}?${QueryStringParser.parseFromObjectsArray(optionsUrlParams)}`;
}

export default {
	buildOptionsUrl
};
